(function () {
  'use strict';
  function update(cart) {
    if (!cart || !Number.isFinite(Number(cart.total_price))) return;
    // Shipping protection is an add-on, not eligible merchandise spend.
    var insuranceTotal = (cart.items || []).reduce(function (total, item) {
      if (Number(item.product_id) !== 10147725115687) return total;
      return total + Number(item.final_line_price != null ? item.final_line_price : item.line_price || 0);
    }, 0);
    var source = document.querySelector('[data-cart-shipping-progress]');
    var popup = document.querySelector('#cart-popup .cartForm');
    // The legacy dropdown replaces its contents after every cart update.
    if (source && popup && !popup.querySelector('[data-cart-shipping-progress]')) {
      popup.prepend(source.cloneNode(true));
    }
    document.querySelectorAll('[data-cart-shipping-progress]').forEach(function (box) {
      var goal = Number(box.dataset.goal), total = Math.max(0, Number(cart.total_price) - insuranceTotal);
      var currency = cart.currency || box.dataset.currency;
      var message = box.querySelector('[data-shipping-message]');
      var progress = box.querySelector('[data-shipping-progress]');
      box.dataset.total = total;
      box.dataset.currency = currency;
      if (currency !== 'USD') {
        message.textContent = 'Free Shipping on orders of $' + goal / 100 + ' USD+.';
        progress.hidden = true;
        box.dataset.qualified = 'false';
        return;
      }
      var remaining = Math.max(0, goal - total);
      var amount = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(remaining / 100);
      var text = remaining ? "You're " + amount + ' away from Free Shipping!' : '🎉 Free Shipping unlocked! 🎉';
      if (message.textContent.trim() !== text) message.textContent = text;
      progress.hidden = false;
      progress.max = goal;
      progress.value = Math.min(goal, total);
      box.dataset.qualified = String(remaining === 0);
    });
  }
  function initial() {
    var box = document.querySelector('[data-cart-shipping-progress]');
    if (box) update({ total_price: Number(box.dataset.total), currency: box.dataset.currency });
  }
  document.addEventListener('textual:cart-updated', function (event) { update(event.detail); });
  document.addEventListener('shopify:section:load', initial);
  window.addEventListener('load', function () {
    if (window.jQuery) {
      window.jQuery(document.body).on('afterGetCart.ajaxCart afterCartLoad.ajaxCart', function (event, cart) { update(cart); });
      window.jQuery(document.body).on('afterChangeItem.ajaxCart', function (event, line, quantity, cart) { update(cart); });
    }
    initial();
  });
  initial();
}());
